/**************************************************************************************************************************************************
*   MODULE NAME     :  AbstractDetail
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  01-04-2021
*   DESCRIPTION     :  Component to load Metrics page
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/
import React from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Tooltip,
  OverlayTrigger,
  Button,
  Tabs,
  Tab
} from "react-bootstrap";
import {
  FaSpinner,
} from "react-icons/fa";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import Select from "react-select";
import { FromToDatePicker } from "../common/datePicker/MyDatePicker";
import { loadAbstractsData } from "../../actions/homeActions";
import * as Helper from "../abstracts/Common/abstractHelper";
import {
  loadAllProduct,
  loadAllCountry,
  loadAllExplanation,
  loadAllStatus,
} from "../../actions/abstractActions";
import { loadUsersData } from "../../actions/userActions";
import MetricsApi from "../../api/MetricsApi";
import { } from "../common/MessagesPool";
import MetricResultsTab from "./MetricResultsTab";
import { loadAggregateMetrics } from "../../actions/metricActions";
import "./Metrics.css";

class Metrics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      title: "",
      authors: "",
      documentSiteOrigin: "",
      siteProcessingDocument: "",
      statusId: "",
      productId: "",
      countryId: "",
      includeDeleted: 0,
      includeLegacyRecords: 0,
      receivedFrom: "",
      abstractLanguage: "",
      institution: "",
      abstract: "",
      notes: "",
      explanationId: "",
      caseManagerId1: "",
      caseManagerId2: "",
      caseManagerId3: "",
      source: "",
      caseIds: "",
      selectedMetrics: [],
      selectAllCheckbox: false,
      disableSearch: true,
      deleteAllowed: this.props.loggedUserDetail.role.includes("Business_Administrator") || this.props.loggedUserDetail.role.includes("IT_Administrator"),
      metricsDate: {
        from: "",
        to: "",
      },
      dateRecordReceived: {
        from: "",
        to: "",
      },
      dateArticleOrdered: {
        from: "",
        to: "",
      },
      dateArticleOrdered2: {
        from: "",
        to: "",
      },
      dateArticleReceived: {
        from: "",
        to: "",
      },
      dateAbstractReviewed: {
        from: "",
        to: "",
      },
      dateArticleReviewed: {
        from: "",
        to: "",
      },
      dateTranslationRequested: {
        from: "",
        to: "",
      },
      dateTranslationReceived: {
        from: "",
        to: "",
      },
      dateAbstractValid: {
        from: "",
        to: "",
      },
      dateArticleValid: {
        from: "",
        to: "",
      },
      dateTranslationValid: {
        from: "",
        to: "",
      },
      dateClosed: {
        from: "",
        to: "",
      },
      dateFlwUpReceived: {
        from: "",
        to: "",
      },
      lockByDate: {
        from: "",
        to: "",
      },
      metricCheckboxes: [
        {
          id: 1,
          text:
            "Calendar days from initial abstract receipt date to completion of Abstract review",
          sm: 6,
        },
        {
          id: 4,
          text: "Number of abstracts received",
          sm: 3,
        },
        {
          id: 5,
          text: "Number of articles ordered",
          sm: 3,
        },
        {
          id: 2,
          text:
            "Calendar days from initial abstract receipt to Non-valid article closeout",
          sm: 6,
        },
        {
          id: 6,
          text: " Number of articles received",
          sm: 3,
        },
        {
          id: 7,
          text: " Number of translations requested",
          sm: 3,
        },
        {
          id: 3,
          text: "Calendar days from article ordered to receipt of article",
          sm: 6,
        },
        {
          id: 8,
          text: "Number of translations received",
          sm: 3,
        },
        {
          id: 9,
          text: " Number of manually-entered abstracts",
          sm: 3,
        },
        {
          id: 10,
          text: "Number of confirmed duplicates from XML Upload",
          sm: 6,
        },
        {
          id: 11,
          text: "Number of abstracts closed",
          sm: 3,
        },
      ],
      showResults: false,
      productList: this.props.productData,
      statusList: this.props.statusData,
      explanationList: this.props.explanationData,
      countryList: this.props.countryData,
      usersList: this.props.usersData,
      siteProcessingList: [
        {
          label: "Global",
          value: "Global",
        },
        {
          label: "Japan",
          value: "Japan",
        },
      ],
      metricsCounts: [],
      activeTab: "metricsSearch",
      searchCriteriaObject: {}
    };
  }
  /**
   * Function to hide/show loader.
   * @param isLoading whether to hide or show loader
   */
  setLoader = (isLoading) => this.setState({ isLoading });
  /**
   * Function to initiate life cycle hooks.
   */
  async componentDidMount() {
    this.setLoader(true);
    try {
      await Promise.all([
        this.loadAllProduct(),
        this.loadAllExplanation(),
        this.loadAllStatus(),
        this.loadAllCountry(),
        this.loadAllUsers(),
      ]);
    } catch (e) {
      this.setLoader(false);
    }
    this.setLoader(false);
  }

  loadAllProduct = async () => {
    let arr = this.state.productList;
    if (!(this.state.productList && this.state.productList.length > 0)) {
        let response = await this.props.loadAllProduct();
        arr = response.data.result
    }
    let resultData = Helper.getFormattedMasterData(arr).sort((a,b) => a.label.localeCompare(b.label));
    this.setState({
      productList: resultData,
    });
  };

  loadAllCountry = async () => {
    let arr = this.state.countryList;
    if (!(this.state.countryList && this.state.countryList.length > 0)) {
        let response = await this.props.loadAllCountry();
        arr = response.data.result
    }
    let resultData = Helper.getFormattedMasterData(arr).sort((a,b) => a.label.localeCompare(b.label));
    this.setState({
      countryList: resultData,
    });
  };

  loadAllExplanation = async () => {
    let arr = this.state.explanationList;
    if (!(this.state.explanationList && this.state.explanationList.length > 0)) {
        let response = await this.props.loadAllExplanation();
        arr = response.data.result
    }
    let resultData = Helper.getFormattedMasterData(arr).sort((a,b) => a.label.localeCompare(b.label));
    this.setState({
      explanationList: resultData,
    });
  };

  loadAllStatus = async () => {
    let arr = this.state.statusList;
    if (!(this.state.statusList && this.state.statusList.length > 0)) {
        let response = await this.props.loadAllStatus();
        arr = response.data.result
    }
    let resultData = Helper.getFormattedMasterData(arr).sort((a,b) => a.label.localeCompare(b.label));
    this.setState({
      statusList: resultData,
    });
  };

  loadAllUsers = async () => {
    let arr = this.state.userList;
    if (!(this.state.userList && this.state.userList.length > 0)) {
        let response = await this.props.loadUsersData();
        arr = response.data.result
    }
    let resultData = arr.map((user) => {
      return {
        label: `${user.firstName} ${user.lastName}`,
        value: user.systemId,
      };
    }).sort((a,b) => a.label.localeCompare(b.label));
    this.setState({
      usersList: resultData,
    });
  };

  handleDateChangeFromTo = (e, type) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleCheckboxChange = (e) => {
    this.setState({
      [e.target.id]: e.target.checked
    })
  }

  handleCheckboxSelection = (id) => {
    let selectedMetrics = [...this.state.selectedMetrics];
    if (selectedMetrics.includes(id)) {
      this.setState((prevState) => ({
        selectedMetrics: prevState.selectedMetrics.filter((e) => e != id),
        selectAllCheckbox: false,
      }), () => this.checkFromToDates());
    } else {
      this.setState((prevState) => ({
        selectedMetrics: [...prevState.selectedMetrics, id],
        selectAllCheckbox: prevState.selectedMetrics.length === 10
      }), () => this.checkFromToDates());
    }
  };

  handleSelectAll = () => {
    if (!this.state.selectAllCheckbox) {
      this.setState({
        selectAllCheckbox: true,
        selectedMetrics: Array(11)
          .fill()
          .map((e, i) => i + 1),
      }, () => this.checkFromToDates());
    } else {
      this.setState({
        selectAllCheckbox: false,
        selectedMetrics: [],
      }, () => this.checkFromToDates());
    }
  };

  onHandleSelectChange = (selectedOption, name) => {
    this.setState({
      [name]: selectedOption,
    });
  };

  _handleDateChangeFromTo = (date, name, dateField) => {
    this.setState(
      (prevState) => ({
        [name]: {
          ...this.state[name],
          [dateField]: date,
        },
      }),
      () => this.checkFromToDates()
    );
  };

  checkFromToDates() {
    let obj = { ...this.state };
    let { selectedMetrics } = this.state;
    let checkDate = false;
    Object.keys(obj).forEach((key) => {
      if (
        key.toLowerCase().includes("date") ||
        key.toLowerCase().includes("locked")
      ) {
        if (
          !(
            obj[key]["from"] === null ||
            obj[key]["to"] === null ||
            obj[key]["from"] === "" ||
            obj[key]["to"] === ""
          ) &&
          new Date(obj[key]["from"]) > new Date(obj[key]["to"])
        ) {
          checkDate = checkDate || true;
        }
      }
    });
    this.setState({
      disableSearch: checkDate || selectedMetrics.length === 0,
    });
  }

  handleResetFunction = () => {
    this.setState({
      title: "",
      authors: "",
      documentSiteOrigin: "",
      siteProcessingDocument: "",
      statusId: "",
      productId: "",
      countryId: "",
      includeDeleted: 0,
      includeLegacyRecords: 0,
      receivedFrom: "",
      abstractLanguage: "",
      institution: "",
      abstract: "",
      notes: "",
      explanationId: "",
      caseManagerId1: "",
      caseManagerId2: "",
      caseManagerId3: "",
      source: "",
      caseIds: "",
      selectedMetrics: [],
      selectAllCheckbox: false,
      metricsDate: {
        from: "",
        to: "",
      },
      disableSearch: true,
      dateRecordReceived: {
        from: "",
        to: "",
      },
      dateArticleOrdered: {
        from: "",
        to: "",
      },
      dateArticleOrdered2: {
        from: "",
        to: "",
      },
      dateArticleReceived: {
        from: "",
        to: "",
      },
      dateAbstractReviewed: {
        from: "",
        to: "",
      },
      dateArticleReviewed: {
        from: "",
        to: "",
      },
      dateTranslationRequested: {
        from: "",
        to: "",
      },
      dateTranslationReceived: {
        from: "",
        to: "",
      },
      dateAbstractValid: {
        from: "",
        to: "",
      },
      dateArticleValid: {
        from: "",
        to: "",
      },
      dateTranslationValid: {
        from: "",
        to: "",
      },
      dateClosed: {
        from: "",
        to: "",
      },
      dateFlwUpReceived: {
        from: "",
        to: "",
      },
      lockByDate: {
        from: "",
        to: "",
      },
      showResults: false,
      searchCriteriaObject: {},
      metricsCounts: []
    });
  };

  getWhereConditions = async () => {
    let obj = {};
    let searchFields = ["title", "authors", "documentSiteOrigin", "siteProcessingDocument", "statusId", "productId", "countryId", "receivedFrom", "abstractLanguage", "institution", "abstract", "notes", "explanationId", "caseManagerId1", "caseManagerId2", "caseManagerId3", "source", "caseIds", "selectedMetrics", "includeLegacyRecords", "includeDeleted"];
    let selectOptions = ["statusId", "productId", "countryId", "explanationId"]
    searchFields.forEach(field => {
      obj[field] = this.state[field];
    });
    let stateCpy = { ...this.state };
    Object.keys(stateCpy).forEach(key => {
      if (key.toLowerCase().includes("date") || key.toLowerCase().includes("locked")) {
        obj[key] = stateCpy[key];
      }
    });
    Object.keys(obj).forEach(key => {
      if(typeof obj[key] === "string") {
        obj[key] = obj[key].trim();
      }
      if (obj[key] === null || obj[key] === "") {
        delete obj[key];
      } else if(Array.isArray(obj[key]) && obj[key].length > 0 && obj[key][0].hasOwnProperty("value")) {
        obj[key] = obj[key].map(e => e.value);
      } else if (Array.isArray(obj[key]) && obj[key].length === 0) {
        delete obj[key];
      } else if (obj[key].hasOwnProperty("value")) {
        obj[key] = obj[key]["value"]
      } else if (obj[key].hasOwnProperty("from") && ((obj[key]["from"] === null || obj[key]["from"] === "") && (obj[key]["to"] === null || obj[key]["to"] === ""))) {
        delete obj[key];
      }
    });
    obj.includeLegacyRecords = obj.includeLegacyRecords == true ? 1 : 0;
    obj.includeDeleted = obj.includeDeleted == true ? 1 : 0;
    await this.setState({
      searchCriteriaObject: obj
    })
    return obj;

  }

  handleSubmitFunction = async () => {
    this.setLoader(true);
    await this.setState({
      showResults: false
    })
    await this.getWhereConditions();
    await this.loadAggregateMetrics();
    await this.setState({
      showResults: true,
      activeTab: "results"
    })
    this.setLoader(false);
  }

  loadAggregateMetrics = async () => {
    let { metricCheckboxes, searchCriteriaObject } = this.state;
    this.setLoader(true);
    try {
      let response = await this.props.loadAggregateMetrics(searchCriteriaObject);
      if (response && response.data && response.data.result) {
        let result = response.data.result;
        let metricsCounts = result.map(v => {
          return {
            text: metricCheckboxes.find(element => element.id === v.id).text,
            ...v,
          }
        });
        await this.setState({
          metricsCounts: metricsCounts,
        })
      } 
    } catch (e) {
      this.setLoader(false);
    }
    this.setLoader(false);
  }

  handleTabChange = (key) => {
    this.setState({
      activeTab: key
    })
  }


  render() {
    const {
      isLoading,
      title,
      documentSiteOrigin,
      siteProcessingDocument,
      authors,
      statusId,
      receivedFrom,
      abstractLanguage,
      institution,
      abstract,
      notes,
      explanationId,
      caseManagerId1,
      caseManagerId2,
      caseManagerId3,
      source,
      caseIds,
      dateRecordReceived,
      dateArticleOrdered,
      dateArticleOrdered2,
      dateArticleReceived,
      dateFlwUpReceived,
      dateClosed,
      dateTranslationValid,
      dateArticleValid,
      dateAbstractValid,
      dateTranslationReceived,
      dateTranslationRequested,
      dateArticleReviewed,
      dateAbstractReviewed,
      savedSearchDataList,
      selectedMetrics,
      metricCheckboxes,
      siteProcessingList,
      selectAllCheckbox,
      statusList,
      countryList,
      productList,
      explanationList,
      usersList,
      productId,
      countryId,
      metricsDate,
      lockByDate,
      disableSearch,
      metricsCounts,
      showResults,
      includeDeleted,
      includeLegacyRecords,
      activeTab,
      searchCriteriaObject,
      deleteAllowed
    } = this.state;



    return (
      <>
        <table className="print-table">
          <thead>
            <tr>
              <td>
                <div className="page-header-space"></div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="CommonWrap dashboardWrap">
                  <Container fluid>
                    <Tabs id="addAbstractTab" activeKey={activeTab} onSelect={key => this.handleTabChange(key)} transition={false}>
                      <Tab eventKey="metricsSearch" title="GLSD Metrics" className="pr-3 pb-2">
                        <div className="metricsWrap mt-2">
                          <Row>
                            <Col sm="auto" className="pr-0 mt-2">
                              <Form.Group controlId="selectAllMetrics">
                                <Form.Check
                                  type="checkbox"
                                  label="Select All Metrics"
                                  checked={selectAllCheckbox}
                                  onChange={this.handleSelectAll}
                                />
                              </Form.Group>
                            </Col>
                            <Col sm="auto" className="ml-2 pr-0 mt-2">From</Col>
                            <Col sm="auto" className="pr-0">
                              <Form.Group controlId="drrFrom" className="inline-form-group">
                                <FromToDatePicker
                                  name="metricsDate"
                                  onChange={(date) =>
                                    this._handleDateChangeFromTo(
                                      date,
                                      "metricsDate",
                                      "from"
                                    )
                                  }
                                  selected={
                                    metricsDate.from === null ? "" : metricsDate.from
                                  }
                                  isInvalid={
                                    new Date(metricsDate.from) > new Date("2999-12-31") ||
                                    new Date(metricsDate.from) < new Date("1970-01-01")
                                  }
                                  placeholder={metricsDate.from}
                                  value={metricsDate.from}
                                  defaultvalue={metricsDate.from}
                                  required
                                />
                              </Form.Group>
                            </Col>
                            <Col sm="auto" className="ml-2 pr-0 mt-2">To</Col>
                            <Col sm="auto" className="pr-0">
                              <Form.Group controlId="drrTo" className="inline-form-group">
                                <FromToDatePicker
                                  name="metricsDate"
                                  onChange={(date) =>
                                    this._handleDateChangeFromTo(date, "metricsDate", "to")
                                  }
                                  selected={metricsDate.to === null ? "" : metricsDate.to}
                                  isInvalid={
                                    new Date(metricsDate.to) > new Date("2999-12-31") ||
                                    new Date(metricsDate.to) < new Date("1970-01-01")
                                  }
                                  placeholder={metricsDate.to}
                                  value={metricsDate.to}
                                  defaultvalue={metricsDate.to}
                                  required
                                />
                                {metricsDate.from &&
                                  metricsDate.to &&
                                  new Date(metricsDate.from) > new Date(metricsDate.to) && (
                                    <Form.Control.Feedback
                                      type="invalid"
                                      className="d-block"
                                    >
                                      From Date should be less than To Date
                                    </Form.Control.Feedback>
                                  )}
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            {metricCheckboxes.map((e) => (
                              <Col sm={e.sm} key={e.id}>
                                <Form.Group controlId={`metricCheckbox${e.id}`}>
                                  <Form.Check
                                    type="checkbox"
                                    label={e.text}
                                    checked={selectedMetrics.includes(e.id)}
                                    onChange={() => this.handleCheckboxSelection(e.id)}
                                  />
                                </Form.Group>
                              </Col>
                            ))}
                          </Row>
                        </div>
                        <hr />
                        <div className="headerpart">
                          <Row>
                            <Col sm={8}>
                              {" "}
                              <h1>Selection Criteria</h1>
                            </Col>
                            <Col sm={2} className="mt-2 text-right">
                              <Form.Group controlId="includeLegacyRecords">
                                <Form.Check
                                  type="checkbox"
                                  label="Include Legacy Records"
                                  checked={includeLegacyRecords}
                                  onChange={this.handleCheckboxChange}
                                />
                              </Form.Group>
                            </Col>
                            <Col sm={2} className="mt-2 text-right">
                             {deleteAllowed && ( <Form.Group controlId="includeDeleted">
                                <Form.Check
                                  type="checkbox"
                                  label="Include Deleted"
                                  checked={includeDeleted}
                                  onChange={this.handleCheckboxChange}
                                />
                              </Form.Group>)}
                            </Col>
                          </Row>
                        </div>
                        <div className="selectionWrap">
                          <Row>
                            <Col sm={2} className="pr-0">
                              <Form.Group controlId="title">
                                <Form.Label>Title</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="title"
                                  value={title}
                                  onChange={this.handleChange}
                                  required
                                />
                              </Form.Group>
                            </Col>
                            <Col sm={2} className="pr-0">
                              <Form.Group controlId="authors">
                                <Form.Label>Author</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="authors"
                                  value={authors}
                                  onChange={this.handleChange}
                                  required
                                />
                              </Form.Group>
                            </Col>
                            <Col sm={2} className="pr-0">
                              <Form.Group controlId="source">
                                <Form.Label>Source</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="source"
                                  value={source}
                                  onChange={this.handleChange}
                                  required
                                />
                              </Form.Group>
                            </Col>
                            <Col sm={2} className="pr-0">
                              <Form.Group controlId="caseIds">
                                <Form.Label>Case ID</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="caseIds"
                                  value={caseIds}
                                  onChange={this.handleChange}
                                  required
                                />
                              </Form.Group>
                            </Col>
                            <Col sm={2} className="pr-0">
                              <Form.Group controlId="caseManagerId2">
                                <Form.Label>Full Text Screener</Form.Label>
                                <Select
                                  name="caseManagerId2"
                                  styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  menuPortalTarget={document.body}
                                  options={usersList}
                                  value={caseManagerId2}
                                  maxMenuHeight={130}
                                  onChange={(selectedOption) =>
                                    this.onHandleSelectChange(
                                      selectedOption,
                                      "caseManagerId2"
                                    )
                                  }
                                  isClearable={true}
                                />
                              </Form.Group>
                            </Col>
                            <Col sm={2}>
                              <Form.Group controlId="productId">
                                <Form.Label>Product</Form.Label>
                                <Select
                                  name="productId"
                                  styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  menuPortalTarget={document.body}
                                  options={productList}
                                  value={productId}
                                  maxMenuHeight={130}
                                  onChange={(selectedOption) =>
                                    this.onHandleSelectChange(selectedOption, "productId")
                                  }
                                  isClearable={true}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={2} className="pr-0">
                              <Form.Group controlId="statusId">
                                <Form.Label> Status</Form.Label>
                                <Select
                                  isMulti
                                  name="statusId"
                                  styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  menuPortalTarget={document.body}
                                  options={statusList}
                                  value={statusId}
                                  maxMenuHeight={130}
                                  onChange={(selectedOption) =>
                                    this.onHandleSelectChange(selectedOption, "statusId")
                                  }
                                  isClearable={true}
                                />
                              </Form.Group>
                            </Col>
                            <Col sm={2} className="pr-0">
                              <Form.Group controlId="explanationId">
                                <Form.Label>Explanation</Form.Label>
                                <Select
                                  name="explanationId"
                                  styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  menuPortalTarget={document.body}
                                  options={explanationList}
                                  value={explanationId}
                                  maxMenuHeight={130}
                                  onChange={(selectedOption) =>
                                    this.onHandleSelectChange(selectedOption, "explanationId")
                                  }
                                  isClearable={true}
                                />
                              </Form.Group>
                            </Col>
                            <Col sm={2} className="pr-0">
                              <Form.Group controlId="caseManagerId3">
                                <Form.Label>Record Closer</Form.Label>
                                <Select
                                  name="caseManagerId3"
                                  styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  menuPortalTarget={document.body}
                                  options={usersList}
                                  value={caseManagerId3}
                                  maxMenuHeight={130}
                                  onChange={(selectedOption) =>
                                    this.onHandleSelectChange(
                                      selectedOption,
                                      "caseManagerId3"
                                    )
                                  }
                                  isClearable={true}
                                />
                              </Form.Group>
                            </Col>
                            <Col sm={2} className="pr-0">
                              <Form.Group controlId="caseManagerId1">
                                <Form.Label>Abstract Record Screener</Form.Label>
                                <Select
                                  name="caseManagerId1"
                                  styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  menuPortalTarget={document.body}
                                  options={usersList}
                                  value={caseManagerId1}
                                  maxMenuHeight={130}
                                  onChange={(selectedOption) =>
                                    this.onHandleSelectChange(
                                      selectedOption,
                                      "caseManagerId1"
                                    )
                                  }
                                  isClearable={true}
                                />
                              </Form.Group>
                            </Col>
                            <Col sm={2} className="pr-0">
                              <Form.Group controlId="countryId">
                                <Form.Label>Country</Form.Label>
                                <Select
                                  name="countryId"
                                  styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  menuPortalTarget={document.body}
                                  options={countryList}
                                  value={countryId}
                                  maxMenuHeight={130}
                                  onChange={(selectedOption) =>
                                    this.onHandleSelectChange(selectedOption, "countryId")
                                  }
                                  isClearable={true}
                                />
                              </Form.Group>
                            </Col>
                            <Col sm={2}>
                              <Form.Group controlId="siteProcessingDocument">
                                <Form.Label>Site of Processing</Form.Label>
                                <Select
                                  name="siteProcessingDocument"
                                  styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  menuPortalTarget={document.body}
                                  options={siteProcessingList}
                                  value={siteProcessingDocument}
                                  maxMenuHeight={130}
                                  onChange={(selectedOption) =>
                                    this.onHandleSelectChange(
                                      selectedOption,
                                      "siteProcessingDocument"
                                    )
                                  }
                                  isClearable={true}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={2} className="pr-0">
                              <Form.Group controlId="receivedFrom">
                                <Form.Label>Received From</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="receivedFrom"
                                  value={receivedFrom}
                                  onChange={this.handleChange}
                                  required
                                />
                              </Form.Group>
                            </Col>
                            <Col sm={2} className="pr-0">
                              <Form.Group controlId="institution">
                                <Form.Label>Institution</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="institution"
                                  value={institution}
                                  onChange={this.handleChange}
                                  required
                                />
                              </Form.Group>
                            </Col>
                            <Col sm={2} className="pr-0">
                              <Form.Group controlId="documentSiteOrigin">
                                <Form.Label> Site of Origin</Form.Label>
                                <Select
                                  name="documentSiteOrigin"
                                  styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  menuPortalTarget={document.body}
                                  options={siteProcessingList}
                                  value={documentSiteOrigin}
                                  maxMenuHeight={130}
                                  onChange={(selectedOption) =>
                                    this.onHandleSelectChange(
                                      selectedOption,
                                      "documentSiteOrigin"
                                    )
                                  }
                                  isClearable={true}
                                />
                              </Form.Group>
                            </Col>
                            <Col sm={2} className="pr-0">
                              <Form.Group controlId="abstract">
                                <Form.Label>Abstract</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="abstract"
                                  value={abstract}
                                  onChange={this.handleChange}
                                  required
                                />
                              </Form.Group>
                            </Col>
                            <Col sm={2} className="pr-0">
                              <Form.Group controlId="notes">
                                <Form.Label>Notes</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="notes"
                                  value={notes}
                                  onChange={this.handleChange}
                                  required
                                />
                              </Form.Group>
                            </Col>
                            <Col sm={2}>
                              <Form.Group controlId="abstractLanguage">
                                <Form.Label>Language</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="abstractLanguage"
                                  value={abstractLanguage}
                                  onChange={this.handleChange}
                                  required
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="6">
                              <Row>
                                <Col sm="4" className="formtextLabel pr-0 mt-4">
                                  Date Record Received:
                    </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <Form.Label>From</Form.Label>

                                    <FromToDatePicker
                                      name="dateRecordReceived"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateRecordReceived",
                                          "from"
                                        )
                                      }
                                      selected={
                                        dateRecordReceived.from === null
                                          ? ""
                                          : dateRecordReceived.from
                                      }
                                      isInvalid={
                                        new Date(dateRecordReceived.from) >
                                        new Date("2999-12-31") ||
                                        new Date(dateRecordReceived.from) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateRecordReceived.from}
                                      value={dateRecordReceived.from}
                                      defaultvalue={dateRecordReceived.from}
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <Form.Label>To</Form.Label>

                                    <FromToDatePicker
                                      name="dateRecordReceived"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateRecordReceived",
                                          "to"
                                        )
                                      }
                                      selected={
                                        dateRecordReceived.to === null
                                          ? ""
                                          : dateRecordReceived.to
                                      }
                                      isInvalid={
                                        new Date(dateRecordReceived.to) >
                                        new Date("2999-12-31") ||
                                        new Date(dateRecordReceived.to) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateRecordReceived.to}
                                      value={dateRecordReceived.to}
                                      defaultvalue={dateRecordReceived.to}
                                      required
                                    />
                                    {dateRecordReceived.from &&
                                      dateRecordReceived.to &&
                                      new Date(dateRecordReceived.from) >
                                      new Date(dateRecordReceived.to) && (
                                        <Form.Control.Feedback
                                          type="invalid"
                                          className="d-block"
                                        >
                                          From Date should be less than To Date
                                        </Form.Control.Feedback>
                                      )}
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                            <Col sm="6">
                              <Row>
                                <Col sm="4" className="formtextLabel pr-0 mt-4">
                                  Date Article Ordered:
                    </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <Form.Label>From</Form.Label>

                                    <FromToDatePicker
                                      name="dateArticleOrdered"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateArticleOrdered",
                                          "from"
                                        )
                                      }
                                      selected={
                                        dateArticleOrdered.from === null
                                          ? ""
                                          : dateArticleOrdered.from
                                      }
                                      isInvalid={
                                        new Date(dateArticleOrdered.from) >
                                        new Date("2999-12-31") ||
                                        new Date(dateArticleOrdered.from) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateArticleOrdered.from}
                                      value={dateArticleOrdered.from}
                                      defaultvalue={dateArticleOrdered.from}
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <Form.Label>To</Form.Label>

                                    <FromToDatePicker
                                      name="dateArticleOrdered"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateArticleOrdered",
                                          "to"
                                        )
                                      }
                                      selected={
                                        dateArticleOrdered.to === null
                                          ? ""
                                          : dateArticleOrdered.to
                                      }
                                      isInvalid={
                                        new Date(dateArticleOrdered.to) >
                                        new Date("2999-12-31") ||
                                        new Date(dateArticleOrdered.to) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateArticleOrdered.to}
                                      value={dateArticleOrdered.to}
                                      defaultvalue={dateArticleOrdered.to}
                                      required
                                    />
                                    {dateArticleOrdered.from &&
                                      dateArticleOrdered.to &&
                                      new Date(dateArticleOrdered.from) >
                                      new Date(dateArticleOrdered.to) && (
                                        <Form.Control.Feedback
                                          type="invalid"
                                          className="d-block"
                                        >
                                          From Date should be less than To Date
                                        </Form.Control.Feedback>
                                      )}
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="6">
                              <Row>
                                <Col sm="4" className="formtextLabel pr-0">
                                  Date Article Ordered2:
                    </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                     <FromToDatePicker
                                      name="dateArticleOrdered2"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateArticleOrdered2",
                                          "from"
                                        )
                                      }
                                      selected={
                                        dateArticleOrdered2.from === null
                                          ? ""
                                          : dateArticleOrdered2.from
                                      }
                                      isInvalid={
                                        new Date(dateArticleOrdered2.from) >
                                        new Date("2999-12-31") ||
                                        new Date(dateArticleOrdered2.from) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateArticleOrdered2.from}
                                      value={dateArticleOrdered2.from}
                                      defaultvalue={dateArticleOrdered2.from}
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <FromToDatePicker
                                      name="dateArticleOrdered2"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateArticleOrdered2",
                                          "to"
                                        )
                                      }
                                      selected={
                                        dateArticleOrdered2.to === null
                                          ? ""
                                          : dateArticleOrdered2.to
                                      }
                                      isInvalid={
                                        new Date(dateArticleOrdered2.to) >
                                        new Date("2999-12-31") ||
                                        new Date(dateArticleOrdered2.to) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateArticleOrdered2.to}
                                      value={dateArticleOrdered2.to}
                                      defaultvalue={dateArticleOrdered2.to}
                                      required
                                    />
                                    {dateArticleOrdered2.from &&
                                      dateArticleOrdered2.to &&
                                      new Date(dateArticleOrdered2.from) >
                                      new Date(dateArticleOrdered2.to) && (
                                        <Form.Control.Feedback
                                          type="invalid"
                                          className="d-block"
                                        >
                                          From Date should be less than To Date
                                        </Form.Control.Feedback>
                                      )}
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                            <Col sm="6">
                              <Row>
                                <Col sm="4" className="formtextLabel pr-0">
                                  Date Article Received:
                    </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <FromToDatePicker
                                      name="dateArticleReceived"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateArticleReceived",
                                          "from"
                                        )
                                      }
                                      selected={
                                        dateArticleReceived.from === null
                                          ? ""
                                          : dateArticleReceived.from
                                      }
                                      isInvalid={
                                        new Date(dateArticleReceived.from) >
                                        new Date("2999-12-31") ||
                                        new Date(dateArticleReceived.from) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateArticleReceived.from}
                                      value={dateArticleReceived.from}
                                      defaultvalue={dateArticleReceived.from}
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                     <FromToDatePicker
                                      name="dateArticleReceived"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateArticleReceived",
                                          "to"
                                        )
                                      }
                                      selected={
                                        dateArticleReceived.to === null
                                          ? ""
                                          : dateArticleReceived.to
                                      }
                                      isInvalid={
                                        new Date(dateArticleReceived.to) >
                                        new Date("2999-12-31") ||
                                        new Date(dateArticleReceived.to) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateArticleReceived.to}
                                      value={dateArticleReceived.to}
                                      defaultvalue={dateArticleReceived.to}
                                      required
                                    />
                                    {dateArticleReceived.from &&
                                      dateArticleReceived.to &&
                                      new Date(dateArticleReceived.from) >
                                      new Date(dateArticleReceived.to) && (
                                        <Form.Control.Feedback
                                          type="invalid"
                                          className="d-block"
                                        >
                                          From Date should be less than To Date
                                        </Form.Control.Feedback>
                                      )}
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="6">
                              <Row>
                                <Col sm="4" className="formtextLabel pr-0">
                                  Date Record Reviewed:
                    </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <FromToDatePicker
                                      name="dateAbstractReviewed"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateAbstractReviewed",
                                          "from"
                                        )
                                      }
                                      selected={
                                        dateAbstractReviewed.from === null
                                          ? ""
                                          : dateAbstractReviewed.from
                                      }
                                      isInvalid={
                                        new Date(dateAbstractReviewed.from) >
                                        new Date("2999-12-31") ||
                                        new Date(dateAbstractReviewed.from) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateAbstractReviewed.from}
                                      value={dateAbstractReviewed.from}
                                      defaultvalue={dateAbstractReviewed.from}
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <FromToDatePicker
                                      name="dateAbstractReviewed"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateAbstractReviewed",
                                          "to"
                                        )
                                      }
                                      selected={
                                        dateAbstractReviewed.to === null
                                          ? ""
                                          : dateAbstractReviewed.to
                                      }
                                      isInvalid={
                                        new Date(dateAbstractReviewed.to) >
                                        new Date("2999-12-31") ||
                                        new Date(dateAbstractReviewed.to) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateAbstractReviewed.to}
                                      value={dateAbstractReviewed.to}
                                      defaultvalue={dateAbstractReviewed.to}
                                      required
                                    />
                                    {dateAbstractReviewed.from &&
                                      dateAbstractReviewed.to &&
                                      new Date(dateAbstractReviewed.from) >
                                      new Date(dateAbstractReviewed.to) && (
                                        <Form.Control.Feedback
                                          type="invalid"
                                          className="d-block"
                                        >
                                          From Date should be less than To Date
                                        </Form.Control.Feedback>
                                      )}
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                            <Col sm="6">
                              <Row>
                                <Col sm="4" className="formtextLabel pr-0">
                                  Date Article Reviewed:
                    </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <FromToDatePicker
                                      name="dateArticleReviewed"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateArticleReviewed",
                                          "from"
                                        )
                                      }
                                      selected={
                                        dateArticleReviewed.from === null
                                          ? ""
                                          : dateArticleReviewed.from
                                      }
                                      isInvalid={
                                        new Date(dateArticleReviewed.from) >
                                        new Date("2999-12-31") ||
                                        new Date(dateArticleReviewed.from) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateArticleReviewed.from}
                                      value={dateArticleReviewed.from}
                                      defaultvalue={dateArticleReviewed.from}
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <FromToDatePicker
                                      name="dateArticleReviewed"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateArticleReviewed",
                                          "to"
                                        )
                                      }
                                      selected={
                                        dateArticleReviewed.to === null
                                          ? ""
                                          : dateArticleReviewed.to
                                      }
                                      isInvalid={
                                        new Date(dateArticleReviewed.to) >
                                        new Date("2999-12-31") ||
                                        new Date(dateArticleReviewed.to) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateArticleReviewed.to}
                                      value={dateArticleReviewed.to}
                                      defaultvalue={dateArticleReviewed.to}
                                      required
                                    />
                                    {dateArticleReviewed.from &&
                                      dateArticleReviewed.to &&
                                      new Date(dateArticleReviewed.from) >
                                      new Date(dateArticleReviewed.to) && (
                                        <Form.Control.Feedback
                                          type="invalid"
                                          className="d-block"
                                        >
                                          From Date should be less than To Date
                                        </Form.Control.Feedback>
                                      )}
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="6">
                              <Row>
                                <Col sm="4" className="formtextLabel pr-0">
                                  Date Translation Requested:
                    </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <FromToDatePicker
                                      name="dateTranslationRequested"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateTranslationRequested",
                                          "from"
                                        )
                                      }
                                      selected={
                                        dateTranslationRequested.from === null
                                          ? ""
                                          : dateTranslationRequested.from
                                      }
                                      isInvalid={
                                        new Date(dateTranslationRequested.from) >
                                        new Date("2999-12-31") ||
                                        new Date(dateTranslationRequested.from) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateTranslationRequested.from}
                                      value={dateTranslationRequested.from}
                                      defaultvalue={dateTranslationRequested.from}
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <FromToDatePicker
                                      name="dateTranslationRequested"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateTranslationRequested",
                                          "to"
                                        )
                                      }
                                      selected={
                                        dateTranslationRequested.to === null
                                          ? ""
                                          : dateTranslationRequested.to
                                      }
                                      isInvalid={
                                        new Date(dateTranslationRequested.to) >
                                        new Date("2999-12-31") ||
                                        new Date(dateTranslationRequested.to) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateTranslationRequested.to}
                                      value={dateTranslationRequested.to}
                                      defaultvalue={dateTranslationRequested.to}
                                      required
                                    />
                                    {dateTranslationRequested.from &&
                                      dateTranslationRequested.to &&
                                      new Date(dateTranslationRequested.from) >
                                      new Date(dateTranslationRequested.to) && (
                                        <Form.Control.Feedback
                                          type="invalid"
                                          className="d-block"
                                        >
                                          From Date should be less than To Date
                                        </Form.Control.Feedback>
                                      )}
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                            <Col sm="6">
                              <Row>
                                <Col sm="4" className="formtextLabel pr-0">
                                  Date Translation Received:
                    </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                      <FromToDatePicker
                                      name="dateTranslationReceived"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateTranslationReceived",
                                          "from"
                                        )
                                      }
                                      selected={
                                        dateTranslationReceived.from === null
                                          ? ""
                                          : dateTranslationReceived.from
                                      }
                                      isInvalid={
                                        new Date(dateTranslationReceived.from) >
                                        new Date("2999-12-31") ||
                                        new Date(dateTranslationReceived.from) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateTranslationReceived.from}
                                      value={dateTranslationReceived.from}
                                      defaultvalue={dateTranslationReceived.from}
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <FromToDatePicker
                                      name="dateTranslationReceived"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateTranslationReceived",
                                          "to"
                                        )
                                      }
                                      selected={
                                        dateTranslationReceived.to === null
                                          ? ""
                                          : dateTranslationReceived.to
                                      }
                                      isInvalid={
                                        new Date(dateTranslationReceived.to) >
                                        new Date("2999-12-31") ||
                                        new Date(dateTranslationReceived.to) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateTranslationReceived.to}
                                      value={dateTranslationReceived.to}
                                      defaultvalue={dateTranslationReceived.to}
                                      required
                                    />
                                    {dateTranslationReceived.from &&
                                      dateTranslationReceived.to &&
                                      new Date(dateTranslationReceived.from) >
                                      new Date(dateTranslationReceived.to) && (
                                        <Form.Control.Feedback
                                          type="invalid"
                                          className="d-block"
                                        >
                                          From Date should be less than To Date
                                        </Form.Control.Feedback>
                                      )}
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="6">
                              <Row>
                                <Col sm="4" className="formtextLabel pr-0">
                                  Date Abstract Valid:
                    </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <FromToDatePicker
                                      name="dateAbstractValid"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateAbstractValid",
                                          "from"
                                        )
                                      }
                                      selected={
                                        dateAbstractValid.from === null
                                          ? ""
                                          : dateAbstractValid.from
                                      }
                                      isInvalid={
                                        new Date(dateAbstractValid.from) >
                                        new Date("2999-12-31") ||
                                        new Date(dateAbstractValid.from) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateAbstractValid.from}
                                      value={dateAbstractValid.from}
                                      defaultvalue={dateAbstractValid.from}
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                     <FromToDatePicker
                                      name="dateAbstractValid"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateAbstractValid",
                                          "to"
                                        )
                                      }
                                      selected={
                                        dateAbstractValid.to === null
                                          ? ""
                                          : dateAbstractValid.to
                                      }
                                      isInvalid={
                                        new Date(dateAbstractValid.to) >
                                        new Date("2999-12-31") ||
                                        new Date(dateAbstractValid.to) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateAbstractValid.to}
                                      value={dateAbstractValid.to}
                                      defaultvalue={dateAbstractValid.to}
                                      required
                                    />
                                    {dateAbstractValid.from &&
                                      dateAbstractValid.to &&
                                      new Date(dateAbstractValid.from) >
                                      new Date(dateAbstractValid.to) && (
                                        <Form.Control.Feedback
                                          type="invalid"
                                          className="d-block"
                                        >
                                          From Date should be less than To Date
                                        </Form.Control.Feedback>
                                      )}
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                            <Col sm="6">
                              <Row>
                                <Col sm="4" className="formtextLabel pr-0">
                                  Date Article Valid:
                    </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <FromToDatePicker
                                      name="dateArticleValid"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateArticleValid",
                                          "from"
                                        )
                                      }
                                      selected={
                                        dateArticleValid.from === null
                                          ? ""
                                          : dateArticleValid.from
                                      }
                                      isInvalid={
                                        new Date(dateArticleValid.from) >
                                        new Date("2999-12-31") ||
                                        new Date(dateArticleValid.from) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateArticleValid.from}
                                      value={dateArticleValid.from}
                                      defaultvalue={dateArticleValid.from}
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <FromToDatePicker
                                      name="dateArticleValid"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateArticleValid",
                                          "to"
                                        )
                                      }
                                      selected={
                                        dateArticleValid.to === null
                                          ? ""
                                          : dateArticleValid.to
                                      }
                                      isInvalid={
                                        new Date(dateArticleValid.to) >
                                        new Date("2999-12-31") ||
                                        new Date(dateArticleValid.to) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateArticleValid.to}
                                      value={dateArticleValid.to}
                                      defaultvalue={dateArticleValid.to}
                                      required
                                    />
                                    {dateArticleValid.from &&
                                      dateArticleValid.to &&
                                      new Date(dateArticleValid.from) >
                                      new Date(dateArticleValid.to) && (
                                        <Form.Control.Feedback
                                          type="invalid"
                                          className="d-block"
                                        >
                                          From Date should be less than To Date
                                        </Form.Control.Feedback>
                                      )}
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="6">
                              <Row>
                                <Col sm="4" className="formtextLabel pr-0">
                                  Date Translation Valid:
                    </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                   <FromToDatePicker
                                      name="dateTranslationValid"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateTranslationValid",
                                          "from"
                                        )
                                      }
                                      selected={
                                        dateTranslationValid.from === null
                                          ? ""
                                          : dateTranslationValid.from
                                      }
                                      isInvalid={
                                        new Date(dateTranslationValid.from) >
                                        new Date("2999-12-31") ||
                                        new Date(dateTranslationValid.from) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateTranslationValid.from}
                                      value={dateTranslationValid.from}
                                      defaultvalue={dateTranslationValid.from}
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                   <FromToDatePicker
                                      name="dateTranslationValid"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateTranslationValid",
                                          "to"
                                        )
                                      }
                                      selected={
                                        dateTranslationValid.to === null
                                          ? ""
                                          : dateTranslationValid.to
                                      }
                                      isInvalid={
                                        new Date(dateTranslationValid.to) >
                                        new Date("2999-12-31") ||
                                        new Date(dateTranslationValid.to) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateTranslationValid.to}
                                      value={dateTranslationValid.to}
                                      defaultvalue={dateTranslationValid.to}
                                      required
                                    />
                                    {dateTranslationValid.from &&
                                      dateTranslationValid.to &&
                                      new Date(dateTranslationValid.from) >
                                      new Date(dateTranslationValid.to) && (
                                        <Form.Control.Feedback
                                          type="invalid"
                                          className="d-block"
                                        >
                                          From Date should be less than To Date
                                        </Form.Control.Feedback>
                                      )}
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                            <Col sm="6">
                              <Row>
                                <Col sm="4" className="formtextLabel pr-0">
                                  Date Closed:
                    </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                   <FromToDatePicker
                                      name="dateClosed"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateClosed",
                                          "from"
                                        )
                                      }
                                      selected={
                                        dateClosed.from === null ? "" : dateClosed.from
                                      }
                                      isInvalid={
                                        new Date(dateClosed.from) >
                                        new Date("2999-12-31") ||
                                        new Date(dateClosed.from) < new Date("1970-01-01")
                                      }
                                      placeholder={dateClosed.from}
                                      value={dateClosed.from}
                                      defaultvalue={dateClosed.from}
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <FromToDatePicker
                                      name="dateClosed"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateClosed",
                                          "to"
                                        )
                                      }
                                      selected={dateClosed.to === null ? "" : dateClosed.to}
                                      isInvalid={
                                        new Date(dateClosed.to) > new Date("2999-12-31") ||
                                        new Date(dateClosed.to) < new Date("1970-01-01")
                                      }
                                      placeholder={dateClosed.to}
                                      value={dateClosed.to}
                                      defaultvalue={dateClosed.to}
                                      required
                                    />
                                    {dateClosed.from &&
                                      dateClosed.to &&
                                      new Date(dateClosed.from) >
                                      new Date(dateClosed.to) && (
                                        <Form.Control.Feedback
                                          type="invalid"
                                          className="d-block"
                                        >
                                          From Date should be less than To Date
                                        </Form.Control.Feedback>
                                      )}
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="6">
                              <Row>
                                <Col sm="4" className="formtextLabel pr-0">
                                Date Follow-up Received:
                    </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <FromToDatePicker
                                      name="dateFlwUpReceived"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateFlwUpReceived",
                                          "from"
                                        )
                                      }
                                      selected={
                                        dateFlwUpReceived.from === null
                                          ? ""
                                          : dateFlwUpReceived.from
                                      }
                                      isInvalid={
                                        new Date(dateFlwUpReceived.from) >
                                        new Date("2999-12-31") ||
                                        new Date(dateFlwUpReceived.from) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateFlwUpReceived.from}
                                      value={dateFlwUpReceived.from}
                                      defaultvalue={dateFlwUpReceived.from}
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                   <FromToDatePicker
                                      name="dateFlwUpReceived"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "dateFlwUpReceived",
                                          "to"
                                        )
                                      }
                                      selected={
                                        dateFlwUpReceived.to === null
                                          ? ""
                                          : dateFlwUpReceived.to
                                      }
                                      isInvalid={
                                        new Date(dateFlwUpReceived.to) >
                                        new Date("2999-12-31") ||
                                        new Date(dateFlwUpReceived.to) <
                                        new Date("1970-01-01")
                                      }
                                      placeholder={dateFlwUpReceived.to}
                                      value={dateFlwUpReceived.to}
                                      defaultvalue={dateFlwUpReceived.to}
                                      required
                                    />
                                    {dateFlwUpReceived.from &&
                                      dateFlwUpReceived.to &&
                                      new Date(dateFlwUpReceived.from) >
                                      new Date(dateFlwUpReceived.to) && (
                                        <Form.Control.Feedback
                                          type="invalid"
                                          className="d-block"
                                        >
                                          From Date should be less than To Date
                                        </Form.Control.Feedback>
                                      )}
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                            <Col sm="6">
                              <Row>
                                <Col sm="4" className="formtextLabel pr-0">
                                  Lock By Date :
                    </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <FromToDatePicker
                                      name="lockByDate"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(
                                          date,
                                          "lockByDate",
                                          "from"
                                        )
                                      }
                                      selected={lockByDate.from === null ? "" : lockByDate.from}
                                      isInvalid={
                                        new Date(lockByDate.from) > new Date("2999-12-31") ||
                                        new Date(lockByDate.from) < new Date("1970-01-01")
                                      }
                                      placeholder={lockByDate.from}
                                      value={lockByDate.from}
                                      defaultvalue={lockByDate.from}
                                      required
                                    />
                                  </Form.Group>
                                </Col>
                                <Col sm={4} className="pr-0">
                                  <Form.Group controlId="drrFrom">
                                    <FromToDatePicker
                                      name="lockByDate"
                                      onChange={(date) =>
                                        this._handleDateChangeFromTo(date, "lockByDate", "to")
                                      }
                                      selected={lockByDate.to === null ? "" : lockByDate.to}
                                      isInvalid={
                                        new Date(lockByDate.to) > new Date("2999-12-31") ||
                                        new Date(lockByDate.to) < new Date("1970-01-01")
                                      }
                                      placeholder={lockByDate.to}
                                      value={lockByDate.to}
                                      defaultvalue={lockByDate.to}
                                      required
                                    />
                                    {lockByDate.from &&
                                      lockByDate.to &&
                                      new Date(lockByDate.from) > new Date(lockByDate.to) && (
                                        <Form.Control.Feedback
                                          type="invalid"
                                          className="d-block"
                                        >
                                          From Date should be less than To Date
                                        </Form.Control.Feedback>
                                      )}
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                        <Row>
                          <Col className="text-right mt-3">
                            <Button
                              variant="primary"
                              className="mr-2"
                              type="reset"
                              onClick={this.handleResetFunction}
                            >
                              Reset
                </Button>
                            <Button
                              variant="primary"
                              className="mr-2"
                              type="button"
                              disabled={disableSearch}
                              onClick={this.handleSubmitFunction}
                            >
                              Generate Metrics
                </Button>
                          </Col>
                        </Row>
                      </Tab>
                      <Tab eventKey="results" title="Metrics Results" className="pr-3 pb-2">
                        <MetricResultsTab
                          showResults={showResults}
                          metricsCounts={metricsCounts}
                          searchCriteriaObject={searchCriteriaObject}
                          masterData={{statusList, countryList, productList, explanationList, usersList}}
                        />
                      </Tab>
                    </Tabs>
                  </Container>
                </div>
                {isLoading && (
                  <div className="loader">
                    <FaSpinner />
                  </div>
                )}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <div className="page-footer-space"></div>
              </td>
            </tr>
          </tfoot>
        </table>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      loggedUserDetail: state.userDataReducer.loggedUserDetail,
      productData: state.abstractDataReducer.productData,
      usersData: state.userDataReducer.usersData,
      countryData: state.abstractDataReducer.countryData,
      statusData: state.abstractDataReducer.statusData,
      explanationData: state.abstractDataReducer.explanationData
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      loadAllProduct,
      loadAllCountry,
      loadAllExplanation,
      loadAllStatus,
      loadUsersData,
      loadAggregateMetrics
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Metrics)
);
